import { sourceLabel } from '@/data/geo';

const GEO_STORAGE_KEY = 'dszh_geo_attribution';

export function rememberGeoAttribution (route, extra = {}) {
    if (!route || !route.query) {
        return null;
    }
    const { utm_source: routeSource, utm_medium: routeMedium, utm_campaign: routeCampaign, utm_content: routeContent } = route.query;
    const source = routeSource || extra.source;
    if (!source) {
        return null;
    }
    const payload = {
        source,
        source_label: sourceLabel(source),
        medium: routeMedium || extra.medium || 'ai-recommend',
        campaign: routeCampaign || extra.campaign || '',
        content: routeContent || extra.content || '',
        landing_path: route.path || extra.landing_path || '',
        entry_url: extra.entry_url || (typeof window !== 'undefined' ? window.location.href : ''),
        referrer: typeof document !== 'undefined' ? document.referrer || '' : '',
        saved_at: new Date().toISOString()
    };
    try {
        window.sessionStorage.setItem(GEO_STORAGE_KEY, JSON.stringify(payload));
        window.localStorage.setItem(GEO_STORAGE_KEY, JSON.stringify(payload));
    } catch (err) {
        console.warn('[geo] failed to persist attribution', err);
    }
    return payload;
}

export function readGeoAttribution () {
    const raw = safeReadStorage('sessionStorage') || safeReadStorage('localStorage');
    if (!raw) {
        return null;
    }
    try {
        return JSON.parse(raw);
    } catch (err) {
        return null;
    }
}

export function resolveGeoAttribution (route) {
    return rememberGeoAttribution(route) || readGeoAttribution();
}

export function createTrackedUrl (basePath, sourceKey, topicSlug, content = 'faq') {
    const params = new URLSearchParams({
        utm_source: sourceKey,
        utm_medium: 'ai-recommend',
        utm_campaign: topicSlug,
        utm_content: content
    });
    return `${basePath}?${params.toString()}`;
}

export function applyPageMeta ({ title, description, canonical, keywords }) {
    if (title) {
        document.title = title;
    }
    setMetaTag('description', description);
    setMetaTag('keywords', Array.isArray(keywords) ? keywords.join(',') : keywords);
    setCanonicalLink(canonical);
}

export function setJsonLd (key, data) {
    const scriptId = `geo-jsonld-${key}`;
    removeById(scriptId);
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = scriptId;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
}

export function clearJsonLd (key) {
    removeById(`geo-jsonld-${key}`);
}

function safeReadStorage (type) {
    try {
        return window[type].getItem(GEO_STORAGE_KEY);
    } catch (err) {
        return null;
    }
}

function setMetaTag (name, content) {
    if (!content) {
        return;
    }
    let node = document.head.querySelector(`meta[name="${name}"]`);
    if (!node) {
        node = document.createElement('meta');
        node.setAttribute('name', name);
        document.head.appendChild(node);
    }
    node.setAttribute('content', content);
}

function setCanonicalLink (canonical) {
    if (!canonical) {
        return;
    }
    let node = document.head.querySelector('link[rel="canonical"]');
    if (!node) {
        node = document.createElement('link');
        node.setAttribute('rel', 'canonical');
        document.head.appendChild(node);
    }
    node.setAttribute('href', canonical);
}

function removeById (id) {
    const node = document.getElementById(id);
    if (node && node.parentNode) {
        node.parentNode.removeChild(node);
    }
}
